import Grid from '@material-ui/core/Grid';
import { FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';

import Select from '~/ui/components/inputs/SelectWithoutAnimation';

import { IOption } from '~/types';

interface IProps {
  clientNoShow: boolean;
  visitedPersonsList: IOption[];
  filteredMembers: IOption[];
}

const VisitPersonSelectFields: FC<IProps> = ({
  clientNoShow,
  visitedPersonsList,
  filteredMembers,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      {!clientNoShow && (
        <>
          <Grid item sm={9}>
            <Select
              control={control}
              errors={errors}
              name="visitedPeople"
              options={visitedPersonsList}
              label="Visited Person"
              isMulti
              hideSelectedOptions={false}
              openMenuOnFocus
            />
          </Grid>
          <Grid item sm={1} />
        </>
      )}
      <Grid item sm={9}>
        <Select
          control={control}
          errors={errors}
          name="visitors"
          isMulti
          label="Visited By"
          options={filteredMembers}
          hideSelectedOptions={false}
          openMenuOnFocus
        />
      </Grid>
    </>
  );
};

export default memo(VisitPersonSelectFields);
